import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Documentation from './pages/Documentation/Documentation';
import { MyContextProvider } from './components/MyContextProvider/MyContextProvider';
import  App  from './pages/Home/App';

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter([
    {
      path: "/",
      element: <App />,
    },    
    {
      path: "/documentation",
      element: <Documentation />,
    },
    {
      path: "/policity",
      element: <PrivacyPolicy />,
    },
  ]);

root.render(
  <MyContextProvider><RouterProvider router={router} /></MyContextProvider>
    
);

